
const loading = {
	state: {
		show: false,
	},

	mutations: {
		SET_LOADING: (state, show) => {
			state.show = show
		}
	},
	actions: {
		SetLoading ({commit},show) {
			commit('SET_LOADING',show)
		}
	}
}

export default loading



// WEBPACK FOOTER //
// ./src/store/modules/loading.js